/* @fflow */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Row from 'components/UIKit/Flex/Row';
import Column from 'components/UIKit/Flex/Column';
import { saveAs } from 'filesaver.js';
import baseStyle from './style';
import { auth } from '../../utils/ajax';
import DropdownButton from 'components/buttons/DropdownButton';
import { dropdown } from 'components/UIKit/decorators';
import DownloadIcon from 'components/icons/DownloadIcon';
import ExitIcon from 'components/icons/ExitIcon';
import ArrowDownIcon from 'components/icons/ArrowDownIcon';
import { fetchToken, clearToken } from 'ducks/auth';
import { connect } from 'react-redux';

class UserDropdown extends Component {
  static propTypes = {
    logout: PropTypes.func.isRequired,
    user: PropTypes.object.isRequired,
    active: PropTypes.bool,
    setActive: PropTypes.func,
    mouseUpHandler: PropTypes.func,
    mouseDownHandler: PropTypes.func,
    dispatch: PropTypes.func,
    token: PropTypes.string,
  };

  componentDidUpdate(prevProps) {
    const { prevToken } = prevProps;
    const { token } = this.props;
    if (token && token !== prevToken) {
      saveAs(
        new Blob([ token ], { type: `text/plain;charset=us-ascii` }),
        `gdc-user-token.${new Date().toISOString()}.txt`
      );
      this.props.dispatch(clearToken());
    }
  }

  getToken = () => {
    this.props.dispatch(fetchToken());
  };

  render(): React.Element {
    let { style, logout, user, active, setActive, mouseDownHandler, mouseUpHandler } = this.props;

    return (
      <Row style={{alignSelf: 'stretch'}}>
        <DropdownButton data-testid="button-header-username" style={{
          paddingLeft: '1.5rem',
          paddingRight: '1rem',
          margin: 0,
          border: 'none',
          borderLeft: '1px solid #e5e5e5',
          ...style
        }}
        PostfixComponent={<ArrowDownIcon />}
        onClick={() => setActive(true)}>
          { user.username }
        </DropdownButton>
          { active &&
            <Column
              className="mdl-shadow--2dp"
              style={baseStyle.dropDown}
              onMouseDown={mouseDownHandler}
              onMouseUp={mouseUpHandler}
            >
              <Row
                data-testid="button-header-download-token"
                className="dropdown-item"
                style={baseStyle.dropDownItem}
                onClick={this.getToken}
              >
                <DownloadIcon style={{marginRight: '0.5rem', fontSize: '1.65rem'}}/>
                Download Token
              </Row>
              <Row
                data-testid="button-header-logout"
                className="dropdown-item"
                style={baseStyle.dropDownItem}
                onClick={logout}
              >
                <ExitIcon style={{marginRight: '0.5rem'}}/>
                Logout
              </Row>
        </Column>}
      </Row>
    );
  }
}

export default connect(
  state => ({
    token: state.auth.token,
  })
)(dropdown(UserDropdown));
